///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import SystemErrorModal from "../../SystemErrorModal";
import Modal from "../../Modal";
import messages from "../../../helpers/messages";
import ChevronRight from "../../icons/ChevronRight";
import WarningIcon from "../../icons/WarningIcon";
import { rejectBidModeCapacityMatch } from "../../../api/capacityMatch";
import SpinnerButton from "../banner/SpinnerButton";

const inital = { loading: false, error: false };

export const RejectBidModal = ({ open, bidId, bidModeId, handleClose }) => {
  const [rejectDetails, setRejectDetails] = useState({ ...inital });
  const { user } = useSelector(state => state.user);

  useEffect(() => {
    !open && setRejectDetails(inital);
  }, [open]);

  const { loading, error } = rejectDetails;

  const handleBidModeReject = () => {
    if (!loading) {
      setRejectDetails({ loading: true, error: false });
      rejectBidModeCapacityMatch(
        bidId,
        bidModeId,
        user.userRoleForManagementUser
      )
        .then(() => {
          setRejectDetails({ loading: false, error: false });
          handleClose(true);
        })
        .catch(() => {
          setRejectDetails({ loading: false, error: true });
        });
    }
  };

  return (
    <>
      <SystemErrorModal
        open={open && error}
        large
        closeModal={() => handleClose(false)}
        handleExit={() => handleClose(false)}
        handleTryAgain={handleBidModeReject}
      />
      <Modal
        title={messages.rejectBid.defaultMessage}
        open={open && !error}
        large={true}
        handleClose={() => handleClose(false)}
        titleClass="modal__title_light uppercase"
        bodyClass="border-top-grey px-24 pt-24"
        closeButtonClass="modal__close-button mr-16 mt-16"
        modalStyle={{ width: 470 }}
      >
        <p className="text-center m-0">
          <WarningIcon height={40} width={40} />
        </p>
        <p
          data-testid="warning-message"
          className="delta-heading text-center text-black pb-4"
        >
          {messages.rejectCapacityMatchWarningMessage.defaultMessage}
        </p>
        <p
          data-testid="reject-message"
          className="font-size-14 text-center text-grayish-blue m-0 pb-8"
        >
          {messages.rejectCapacityMatchMessage.defaultMessage}
          <span className="font-bold">
            {" "}
            {messages.thisCannotBeUndone.defaultMessage}
          </span>
        </p>

        <div className="grid fr my-24">
          <div className="grid__cell pl-8">
            {loading ? (
              <SpinnerButton minWidth="96px" />
            ) : (
              <button
                data-testid="confirm-button"
                className="text-button one-whole cursor-pointer univers-67-bold-cond short-button text-red-failure-dark"
                onClick={handleBidModeReject}
              >
                <>
                  {messages.reject.defaultMessage}
                  <ChevronRight
                    className="align-text-bottom ml-8"
                    fill="#c71e0c"
                  />
                </>
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RejectBidModal;
